import { fmtDate, todayIso } from '../../ui/format';

/** "Data through 06 Sep, uploaded 11 Sep" and whether that is old enough to flag (V2 D93). */
export function freshness(upload: { uploaded_at: string; range_end: string | null } | null | undefined, dataThrough?: string): { text: string; stale: boolean } {
  if (!upload) return { text: dataThrough ? `Data through ${fmtDate(dataThrough, { weekday: false })}` : 'No data loaded', stale: !dataThrough };
  const uploaded = upload.uploaded_at.slice(0, 10);
  const ageDays = Math.round((Date.parse(todayIso()) - Date.parse(uploaded)) / 86_400_000);
  const through = dataThrough ?? upload.range_end;
  return {
    text: `Data through ${through ? fmtDate(through, { weekday: false }) : '–'}, uploaded ${ageDays === 0 ? 'today' : ageDays === 1 ? 'yesterday' : fmtDate(uploaded, { weekday: false })}`,
    stale: ageDays > 8,
  };
}
